import { memo } from "react";

import { Text } from "@react/components/Text";
import { tw } from "classnames";

type Props = {
  showCompareAtPriceValueFootnote: boolean;
  showReviewsFootnote: boolean;
};

const styles = {
  base: tw("text-tertiary"),
};

const FootnotesBase = ({
  showCompareAtPriceValueFootnote,
  showReviewsFootnote,
}: Props) => {
  return (
    <>
      {showReviewsFootnote && (
        <Text as="caption" className={styles.base} size="xs">
          * Reviews are an aggregate of bundle components
        </Text>
      )}
      {showCompareAtPriceValueFootnote && (
        <Text as="caption" className={styles.base} size="xs">
          ** Value is based on individual item pricing
        </Text>
      )}
    </>
  );
};

export const Footnotes = memo(FootnotesBase);
